/* eslint-disable complexity */
/* eslint-disable max-lines-per-function */
// eslint-disable-next-line max-lines-per-function
define(function (require) {
    const URIEntities = require('lib/URIEntities');
    require('lib/history.src');
    const { equals } = require('ramda');
    const browser = require('Cloud/browser');
    const { isFeature } = require('Cloud/Application/FeaturesEs6');
    const app = require('Cloud/Application/app');
    const { STORAGE_REGEXP, UNMODIFIED_CLOUD_SPACE } = require('reactApp/constants/magicIdentificators');
    const { store } = require('reactApp/store');
    const { getItemById } = require('reactApp/modules/storage/storage.selectors');
    const { captureMessage } = require('@sentry/browser');
    const { BACK_URL, IS_B2B_BIZ_USER } = require('reactApp/appHelpers/configHelpers');
    const { _path_join } = require('reactApp/utils/urlHelper');
    const { EStorageType } = require('reactApp/modules/storage/storage.types');
    const { IS_MY_TEAM } = require('reactApp/appHelpers/configHelpers');

    const { bytes_used } = app.getParam('user.cloud.space') || {};

    const IS_ROOT_REDIRECT_TO_REACT =
        isFeature('start-page-root') &&
        isFeature('start-page') &&
        !app.getParam('ANONYM_USER') &&
        !app.getParam('BIZ_USER') &&
        !browser.isMobile() &&
        bytes_used !== 0 &&
        bytes_used !== UNMODIFIED_CLOUD_SPACE;

    const states = [];
    let actualStateIndex = null;
    let lastStateIndex = null;
    let storages;
    let expectedState;

    const stateController = {
        resetStates() {
            if (lastStateIndex != null && lastStateIndex <= states.length - 1) {
                states.length = lastStateIndex + 1;
                this.removeLastSavedStateIndex();
                this.setLastStateIndex(null);
            }
        },
        getLastState() {
            return this.getStateByIndex(lastStateIndex);
        },
        getLastStateIndex() {
            if (lastStateIndex != null && lastStateIndex < states.length - 1) {
                return lastStateIndex;
            }
            return states.length - 1;
        },
        setLastStateIndex(index) {
            lastStateIndex = index;
            return lastStateIndex;
        },
        saveLastStateIndex() {
            actualStateIndex = this.getLastStateIndex();
        },
        removeLastSavedStateIndex() {
            actualStateIndex = null;
        },
        getLastSavedState() {
            const index = actualStateIndex != null ? actualStateIndex : -1;

            if (index === -1) {
                return null;
            }

            return this.getStateByIndex(index);
        },
        getStateByIndex(index) {
            if (index != null && states[index]) {
                return states[index];
            }
            return states[states.length - 1] || { storage: 'unknown' };
        },
    };

    function _append(target) {
        const sources = [].slice.call(arguments, 1);

        for (let i = 0, len = sources.length; i < len; i++) {
            const source = sources[i];

            if (source) {
                for (const prop in source) {
                    if (source.hasOwnProperty(prop) && !target.hasOwnProperty(prop)) {
                        target[prop] = source[prop];
                    }
                }
            }
        }

        return target;
    }

    function _getStartUrl() {
        // Opera и Safari возвращают декоженные pathname, если есть в названии символ "%", то _decode упадет
        return window.history.location
            .toString()
            .substr(8)
            .replace(/^[^/]+/, '')
            .replace(/#.*?$/, '');
    }

    function isDifferentState(next, prev) {
        if (!prev) {
            prev = stateController.getLastState();
        }

        if (!prev || !next) {
            return true;
        }

        if (prev.storage != next.storage) {
            return true;
        }

        const prevId = prev.id;
        const nextId = next.id;

        if (
            next.storage === prev.storage &&
            (next.storage === 'search' || next.storage === 'attaches') &&
            next.params &&
            prev.params &&
            (next.params.query !== prev.params.query ||
                next.params.searchType !== prev.params.searchType ||
                next.params.folderId !== prev.params.folderId ||
                next.params.type !== prev.params.type)
        ) {
            return true;
        }

        if (next.storage.includes('home') && next.params && prev.params && next.params.weblink !== prev.params.weblink) {
            return true;
        }

        if (`${prevId}/` == nextId || `${nextId}/` == prevId) {
            return false; // CLOUDWEB-6606
        }

        return prevId != nextId;
    }

    function historyBack(pos, isPopstate, force) {
        if (stateController.getLastStateIndex() >= 0) {
            const offset = isPopstate ? pos : 0;

            if (pos > stateController.getLastStateIndex()) {
                if (!force) {
                    pos = stateController.getLastStateIndex();
                }
            } else if (pos <= 0) {
                pos = 1;
            }

            let to = -pos;

            if (history.length - pos <= 0) {
                if (force) {
                    RADAR('history_back-more-when-history');

                    stateController.saveLastStateIndex();
                    expectedState = states[stateController.setLastStateIndex(stateController.getLastStateIndex() - pos)];

                    pos = history.length - 1;
                    to = -pos;
                } else {
                    RADAR('history_back-unexpected-pos');
                }
            } else {
                stateController.saveLastStateIndex();
                stateController.setLastStateIndex(stateController.getLastStateIndex() - pos);
            }

            to += offset;

            RADAR('router_goback');

            if (to != 0) {
                if (to > 0) {
                    // this may be an error
                    RADAR('history_positive-back');
                }

                history.go(to);
                return true;
            }
        }
        return false;
    }

    return function (app, _) {
        const IS_WEBVIEW = app.getParam('IS_WEBVIEW');

        function _stateError(state, errorMsg, errorGroup, url) {
            errorGroup = errorGroup || '';
            url = url || history.location.href;

            state.error = errorMsg;
            state.url = url;

            RADAR(`router_${state.error}`);

            captureMessage(`${errorGroup.toUpperCase()} STATE`, {
                arguments: url,
            });
        }

        const storagesRedirect = {};
        storagesRedirect.start = null;
        function _checkState(state, url, errorGroup) {
            let storage = state.storage;
            const id = state.id;
            let updateUrl = false;

            if (!state.error) {
                const redirect = storagesRedirect[storage];

                if (redirect === false) {
                    _stateError(state, 'forbidden', errorGroup, url);
                } else if (redirect) {
                    storage = state.storage = redirect;
                    updateUrl = true;
                }

                let showError = false;

                if (showError) {
                    _stateError(state, 'norm_not_found', errorGroup, url);
                }
            }

            if (!state.error) {
                if (!(typeof id === 'string' || id instanceof String)) {
                    state.wrong_id = id;
                    state.id = '/';

                    _stateError(state, 'bad_id', errorGroup, url);
                }
            }

            if (!state.error) {
                if (!storages[state.storage]) {
                    _stateError(state, 'bad_storage', errorGroup, url);
                }
            }

            if (updateUrl) {
                state.url = _href(state.id, state.storage, null, _stringify_query_params(state.params));
            }

            return state;
        }

        function _matchState(url) {
            const isStart = !url;

            if (isStart) {
                url = _getStartUrl();

                // throw new Error('Undefined url');
            }

            let params = '';
            if (url) {
                if (!url.match(/\/attaches\/\d{20}\/\/public\//)) {
                    // Пропускаем для аттачей, у которых внутри веблинк
                    url = url.replace(/\/{2,}/g, '/');
                }
                url = url.replace(/\?(.*)$/g, function (str, _params) {
                    params = _params || '';
                    return '';
                });
            }

            if (!url || url === '/') {
                url = IS_ROOT_REDIRECT_TO_REACT ? '/start/' : '/home/';
            }

            if (url === '/home') {
                url = '/home/';
            }

            const str = URIEntities.decode(url);
            let matches = str.match(STORAGE_REGEXP);

            if (!matches) {
                matches = str.match(/^\/?[A-Z0-9]{32}(\/)?$/);

                if (matches) {
                    matches[1] = 'files';
                    matches[2] = matches[0];
                }
            }

            const state = {
                params: {},
            };

            if (matches) {
                const storage = matches[1];
                if (storagesRedirect[storage] === null) {
                    // cloudweb-5007 специальная схема для сторажей без поддержки прямых урлов
                    const paramsMatches = URIEntities.decode(params).match(/^id=(\/.*)?$/);
                    if (paramsMatches && paramsMatches[1]) {
                        matches[2] = paramsMatches[1];
                    }
                }
                let id = (matches[2] || '').replace(/\/$/, '');
                if (storage !== EStorageType.attaches || !id.match(/([A-Za-z0-9]+)\/\/public\//)) {
                    // Пропускаем для аттачей, у которых внутри веблинк
                    id = id.replace(/\/{2,}/g, '/');
                }

                state.storage = storage;
                state.id = id;

                if (storage === 'search' || storage === 'attaches') {
                    state.params = _parse_query_params(params);
                    state.url = _href(state.id, state.storage, null, params);

                    if (params) {
                        url += `?${_stringify_query_params(state.params)}`;
                    }
                } else {
                    state.url = _href(state.id, state.storage);

                    state.params = _parse_query_params(params);
                }

                _checkState(state, url, 'match');

                if (!app.available(state.storage).path_as_id && state.id.charAt(0) === '/') {
                    state.id = state.id.replace(new RegExp('^/'), '');
                }
            } else {
                _stateError(state, 'cant_match', 'match', url);
            }

            return state;
        }

        function _parse_query_params(params) {
            if (!params) {
                return {}; // иначе в урл попадет строка '?='
            }
            const res = {};
            params = (params || '').split('&') || [];
            for (var i = 0, pair, l = params.length; i < l; i++) {
                pair = (params[i] || '').split('=');
                res[pair[0]] = URIEntities.decode(pair[1] || '');
            }
            if (res.wv && res.wv === '1?') {
                res.wv = '1';
            }
            return res;
        }

        function _stringify_query_params(params) {
            const res = [];
            params = params || {};

            if (typeof params !== 'object') {
                throw new Error(`_stringify_query_params: expected params to be an object, ${typeof params} received.`);
            }
            Object.keys(params).forEach(function (key) {
                res.push(`${key}=${URIEntities.encode(params[key] || '')}`);
            });
            return res.join('&');
        }

        function _href(id, storage, params, queryParams) {
            let url;

            storage = storage || _.sid();
            queryParams = queryParams || '';

            let item = getItemById(store.getState(), id, storage) || app.get ? app.get(id, storage) || params : void 0;
            if (!item && app.get && id && id.charAt(0) === '/') {
                item = app.get(id.substr(1), storage);
            }
            let specialId;

            if (storagesRedirect[storage] === null && id && id !== '/') {
                // CLOUDWEB-5007 специальная схема для сторажей без поддержки прямых урлов
                specialId = (id.charAt(0) !== '/' ? '/' : '') + id;
                id = '';
            }

            if (!item) {
                url = _path_join('/', storage, id);
            } else if (item.kind === 'storage') {
                url = _path_join('/', storage, '/');
            } else if (item.isFolder) {
                url = _path_join('/', storage, id, '/');
            } else {
                url = _path_join('/', storage, id);
            }

            url = URIEntities.encode(url);

            if (specialId) {
                url = _path_join(url, `?id=${URIEntities.encode(specialId)}`);
            }

            if (queryParams) {
                url += (specialId ? '&' : '?') + queryParams;
            }

            if (BACK_URL && !queryParams) {
                url += `?back_url=${BACK_URL}`;
            }

            return url;
        }

        function buildHref(state, params, queryParams) {
            state = _normalizeState(state);

            if (state.url) {
                const query = _stringify_query_params(queryParams);
                if (!query) {
                    return state.url;
                }
                return `${state.url}?${query}`;
            }

            return _href(state.id, state.storage, params, _stringify_query_params(queryParams ? queryParams : state.params));
        }

        function _normalizeState(state, clone, nativeState) {
            if (typeof state === 'string') {
                if (state === ':start:') {
                    state = _matchState();
                    state.__parent = '/';
                } else if (state === ':current:') {
                    state = stateController.getLastState();
                } else {
                    state = _matchState(state);
                }
            }

            state = state || {};

            if (clone) {
                state = _append({}, state);
            }
            if (nativeState && typeof nativeState.index === 'number') {
                _append(state, states[nativeState.index]);
            }

            state.storage = state.storage || _.sid() || 'home';

            state.id = state.id || '/';
            if (state.storage !== EStorageType.attaches || !state.id.match(/([A-Za-z0-9]+)\/\/public\//)) {
                state.id = state.id.replace(/\/{2,}/g, '/');
            }

            state.params = state.params || {};

            return _checkState(state, state.url, 'normalize');
        }

        function isStorageChanged(state, prev) {
            prev = prev || stateController.getLastState();

            return prev.storage !== (state && state.storage);
        }

        function treeContains(state) {
            state = state || stateController.getLastState();

            return _.tree().has(state.id);
        }

        function storedInTheSameFolder(state, prev) {
            prev = prev || stateController.getLastState();

            if (app.isAttaches()) {
                return equals(state.params, prev.params);
            }
            return _.tree().folder(prev.id) === _.tree().folder(state.id);
        }

        function _pushExpectedState() {
            const state = expectedState;
            expectedState = null;

            history.replaceState({ index: stateController.getLastStateIndex() }, null, buildHref(state));
        }

        function _isExpectedState(state) {
            return !expectedState || !isDifferentState(state, expectedState);
        }

        function _isFolder(state) {
            if (typeof state.__isFolder === 'boolean') {
                return state.__isFolder;
            }

            const tree = _.tree(state.storage);

            if (tree && tree.has(state.id)) {
                return (state.__isFolder = tree.isFolder(state.id));
            }

            const idParts = state.id.split('/');
            idParts.pop();
            return !idParts.includes('.');
        }

        function _getParent(state) {
            if (typeof state.__parent === 'string') {
                return state.__parent;
            }

            if (_.tree) {
                const tree = _.tree(state.storage);

                if (tree && tree.has(state.id)) {
                    return (state.__parent = tree.folder(state.id));
                }
            }

            const idParts = state.id.split('/');
            idParts.pop();
            return idParts.join('/');
        }

        function _removeFilesHistory(isPopstate) {
            const nativeState = isPopstate && history.state;
            const curState = stateController.getLastState();
            const curIndex = curState.index;

            let pos;
            if (nativeState && nativeState.index !== void 0) {
                pos = nativeState.index;

                if (curState.index < pos) {
                    return false;
                }
            } else {
                pos = Array.reduceRight(
                    states.slice(0, curState.index),
                    function (backPos, state, pos) {
                        if (backPos === -1 && pos <= curIndex && _isFolder(state) !== false) {
                            return pos;
                        }
                        return backPos;
                    },
                    -1
                );
            }

            if (pos !== -1) {
                pos = stateController.getLastStateIndex() - pos;

                return historyBack(pos, isPopstate, true);
            }
            return false;
        }

        function _onPopState(state, isPopstate, nativeState, forceReload) {
            let tree;
            let deletedState;
            let curState;

            // CLOUDWEB-7400;
            if (state.storage === 'search') {
                return true;
            }

            // Из просмотра файла можно перейти только в родительскую папку
            // На мобильных пабликах, при просмотре файла без превью, он открывается как отдельная "хлебная крошка". и нужно иметь возможность перейти на любого родителя
            if (state.storage === 'public' && browser.isMobile()) {
                return true;
            }

            tree = isPopstate && _.tree(state.storage);
            deletedState = isPopstate && tree && !(tree.has(state.id) || getItemById(store.getState(), state.id, state.storage));
            curState = stateController.getLastState();

            if (_isFolder(state) === false) {
                state.group = 'file';
            } else if (!forceReload && curState.group === 'file' && !deletedState) {
                if (_removeFilesHistory(isPopstate) === true) {
                    return false;
                }
            }

            if (deletedState) {
                const index = nativeState.index == void 0 ? state.index : nativeState.index;

                if (!states[index]) {
                    return;
                }

                const oldState = states[index];
                const newState = _normalizeState(oldState, true);
                newState.id = _getParent(oldState);
                _normalizeState(newState);

                states[index] = newState;

                const parentUrl = buildHref(newState);

                setTimeout(function () {
                    nativeState.forceIsPopstate = isPopstate;
                    history.replaceState(nativeState, null, parentUrl);
                }, 10);

                return false;
            }

            return true;
        }

        storages = app.settings.storages || {};

        function setTitle(stringOrState) {
            let title = '';
            const titleDelimiter = IS_WEBVIEW ? '' : ' / ';
            let titleSuffix = IS_B2B_BIZ_USER ? 'VK WorkDisk' : 'Облако Mail.ru';

            if (typeof stringOrState === 'string') {
                title = stringOrState;
            } else {
                const state = stringOrState || stateController.getLastState();
                const item = getItemById(store.getState(), state.id, state.storage) || (app.get && app.get(state.id, state.storage));

                title = '';

                if (/(stock|shared)/.test(state.storage)) {
                    title += app.settings.storages[state.storage].title + titleDelimiter;
                } else if (item) {
                    if (!(state.id === '/' && state.storage === 'home')) {
                        title += item.name + titleDelimiter;
                    }
                } else if (!app.user.isAuthorized()) {
                    title += 'Войти в ';
                }
            }

            setTimeout(function () {
                document.title = (title || '') + (IS_WEBVIEW ? '' : titleSuffix);
            }, 0);
        }

        Object.assign(app, {
            buildHref,
            setTitle,
        });

        Object.assign(_, {
            history: {
                currentState(actualState) {
                    if (actualState) {
                        return stateController.getLastSavedState() || stateController.getLastState();
                    }
                    return stateController.getLastState();
                },
                buildHref,
                setState(state, fromHistory, isPopstate, forceReload) {
                    const nativeState = isPopstate && history.state;
                    state = _normalizeState(state, false, nativeState);

                    const prev = this.currentState(isPopstate);
                    stateController.removeLastSavedStateIndex();
                    stateController.setLastStateIndex(stateController.getLastStateIndex());

                    if (!_isExpectedState(state)) {
                        if (!isPopstate) {
                            RADAR('history_unpop-unexpected-state');
                        }
                        _pushExpectedState();
                        return { prevent: true };
                    }

                    const hasDiff = isDifferentState(state, prev);
                    let bigDeal;

                    if (!isStorageChanged(state, prev) && state && state.storage === 'search') {
                        bigDeal = (hasDiff || fromHistory) && state.id === prev.id;
                    } else {
                        bigDeal =
                            (hasDiff || fromHistory) &&
                            (isStorageChanged(state, prev) ||
                                !treeContains(prev) ||
                                !treeContains(state) ||
                                !storedInTheSameFolder(state, prev));
                    }

                    const result = {
                        state,
                        prev,

                        hasDiff,
                        bigDeal,
                        isStorageChanged: isStorageChanged(state, prev),
                    };

                    if (!fromHistory || isPopstate) {
                        if (states.length && _onPopState(state, isPopstate, nativeState, forceReload) === false) {
                            result.prevent = true;
                            return result;
                        }
                    }

                    if (hasDiff) {
                        _getParent(state);

                        if (isPopstate) {
                            if (nativeState && nativeState.index !== void 0) {
                                stateController.removeLastSavedStateIndex();
                                const lastStateIndex = stateController.setLastStateIndex(nativeState.index);
                                states[lastStateIndex] = state;
                                state.index = lastStateIndex;
                            } else {
                                stateController.resetStates();

                                states.pop();
                                const index = stateController.getLastStateIndex();
                                states[index] = state;
                                state.index = index;
                            }
                        } else {
                            stateController.resetStates();

                            states.push(state);

                            state.index = stateController.getLastStateIndex();
                        }
                    } else if (nativeState) {
                        state.index = nativeState.index;
                    }

                    // Теперь на пабликах элемент берется из стора, а не из tree, без
                    // setTimeout элементы не успевают попасть в стор
                    setTimeout(() => setTitle(state), 100);

                    return result;
                },

                historySet(state, checkCurrent) {
                    const newUrl = IS_MY_TEAM ? buildHref(state, state.params, {}) : buildHref(state);

                    const newBrowserState = { index: stateController.getLastStateIndex() };
                    if (checkCurrent) {
                        const prev = stateController.getLastState();
                        const prevUrl = buildHref(prev);
                        const prevBrowserState = history.state;

                        if (prevUrl === newUrl) {
                            if (!prevBrowserState || prevBrowserState.index !== newBrowserState.index) {
                                RADAR('router_replace');
                                history.replaceState(newBrowserState, null, newUrl);
                            }
                        }
                        return;
                    }

                    history.pushState(newBrowserState, null, newUrl);
                },
            },
        });
    };
});
